export default __webpack_public_path__ + "static/card3-64994924e0fb5ae6e2f990109500fc23.webp";